import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight, FiFacebook, FiShield, FiCpu, FiTarget } = FiIcons;

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function Hero() {
  return (
    <section className="relative bg-brand-dark pt-48 pb-24 lg:pt-64 lg:pb-44 overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80"
          alt="Home services background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-dark via-brand-dark/90 to-brand-dark"></div>
      </div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-4 mb-12">
            <div className="relative flex h-5 w-5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-blue opacity-75"></span>
              <span className="relative inline-flex rounded-full h-5 w-5 bg-brand-blue shadow-[0_0_20px_#009FE3]"></span>
            </div>
            <span className="animate-neon text-white font-black text-2xl md:text-3xl uppercase tracking-[0.2em] italic drop-shadow-[0_0_15px_rgba(0,159,227,0.8)]">
              Now Serving West Valley, Arizona
            </span>
          </div>

          <h1 className="text-6xl md:text-8xl lg:text-[10rem] font-black tracking-tighter mb-8 leading-[0.8] uppercase italic text-brand-cream">
            GET IN EVERY <br className="hidden md:block"/>
            <span className="text-brand-blue">MAILBOX.</span>
          </h1>

          <p className="mt-10 text-xl md:text-3xl text-brand-cream/80 max-w-4xl mx-auto leading-tight mb-14 font-medium">
            The West Valley's only home services co-op mailer with <strong>Category Exclusivity</strong>. One plumber, one roofer, one landscaper — no competing bids.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mb-24">
            <button
              onClick={() => scrollTo('reserve')}
              className="w-full sm:w-auto bg-brand-blue hover:bg-brand-blue/90 text-white px-12 py-7 rounded-[2.5rem] text-2xl font-black uppercase tracking-tight transition-all shadow-2xl shadow-brand-blue/30 flex items-center justify-center gap-3 active:scale-95 border-b-[6px] border-brand-dark/30"
            >
              Claim Your Trade <SafeIcon icon={FiArrowRight} />
            </button>
            <a
              href="https://www.facebook.com/thegyrohero"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto bg-white/10 hover:bg-white/20 text-white px-12 py-7 rounded-[2.5rem] text-2xl font-black uppercase tracking-tight transition-all backdrop-blur-md flex items-center justify-center gap-3 border-2 border-white/20 active:scale-95"
            >
              <SafeIcon icon={FiFacebook} /> Message Sean
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-12 text-brand-cream/40 font-black uppercase text-xs tracking-[0.4em]">
            <div className="flex items-center gap-3"><SafeIcon icon={FiShield} className="text-brand-blue text-lg" /> No Competing Trades</div>
            <div className="flex items-center gap-3"><SafeIcon icon={FiCpu} className="text-brand-blue text-lg" /> Design Help Included</div>
            <div className="flex items-center gap-3"><SafeIcon icon={FiTarget} className="text-brand-blue text-lg" /> 5,000 Homes / Drop</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
